import { usePromo } from '@entities/promo-video';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { promoCreateSchema, promoUpdateSchema, type PromoFormValues } from '../lib';

export const usePromoForm = (videoId: number) => {
  const { promo } = usePromo(videoId);

  const { reset, ...methods } = useForm<PromoFormValues>({
    resolver: yupResolver((isNaN(videoId) ? promoCreateSchema : promoUpdateSchema) as any),
    defaultValues: {
      file: '',
      video_type: 'B',
    },
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  });

  const hasDirtyFields = () => {
    const {
      formState: { dirtyFields },
    } = { ...methods };

    return Object.keys(dirtyFields).length > 0;
  };

  useEffect(() => {
    if (promo) {
      reset({
        title: promo.title,
        screenshot_url: promo.screenshot_url,
        video_type: promo.video_type,
        url: promo?.embed_url || promo?.metadata?.FileName,
      });
    }
  }, [promo, reset]);

  return {
    methods: { reset, ...methods },
    hasDirtyFields: hasDirtyFields(),
  };
};
